var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTruck = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4.826,
  cy: 13.087,
  r: 1.313,
  stroke: "#231F20",
  strokeWidth: 1.2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.479,
  cy: 13.087,
  r: 1.313,
  stroke: "#231F20",
  strokeWidth: 1.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.26 13.087H9.61m.956 0H9.61m4.782 0h.271a.5.5 0 0 0 .354-.146l.185-.186a.5.5 0 0 0 .147-.353V8.964a.5.5 0 0 0-.116-.32l-1.08-1.296-1.046-1.255a.5.5 0 0 0-.384-.18H9.61m0 0v7.174m0-7.174V4.5a.5.5 0 0 0-.5-.5H1.5a.5.5 0 0 0-.5.5v8.087a.5.5 0 0 0 .5.5h1.891",
  stroke: "#231F20",
  strokeWidth: 1.2,
  strokeLinecap: "round"
})));
export default SvgTruck;